import afLocale from 'element-ui/lib/locale/lang/af-ZA'
import home from './af/home'

const af = {
    language: 'Afrikaans',
    message: {
        'home': {
            ...home,
            enterEmail: 'Voer asseblief e-pos in',
            save: 'Stoor',
            saveSuccess: 'Suksesvol gestoor',
            pointHistory: 'Puntegeskiedenis',
            type: 'Tipe',
            remark: 'Opmerking',
            pendingComment: 'Hangende beoordeling',
            commented: 'Beoordeel',
            selectDate: 'Kies datum',
            loginSuccess: 'Aanmelding suksesvol',
            loginFail: 'Aanmelding het misluk',
            close: 'Maak toe',
            required: 'Verpligtend',
            nickname: 'Bynaam',
            enterNickname: 'Voer asseblief bynaam in',
            gender: 'Geslag',
            male: 'Manlik',
            female: 'Vroulik',
            secret: 'Privaat',
            birthday: 'Verjaarsdag',
            checkoutLoadFailed: 'Kon nie betaalinligting laai nie. Probeer asseblief later weer.',
            checkoutErrorTitle: 'Kennisgewing',
            goAddAddress: 'Voeg afleweringsadres by',
            shop_order_selectOrAddAddress: 'Voeg asseblief eers \'n afleweringsadres by en stel dit as verstek voordat jy uitteken.',
            shop_order_cartEmpty: 'Die mandjie is leeg, kan nie uitteken nie.',
            shop_order_cartHasNotActive: 'Daar is ongepubliseerde of ongeldige items, kan nie uitteken nie.',
            shop_order_cartHasNotMarketable: 'Daar is items wat onttrek is, kan nie uitteken nie.',
            shop_order_cartHasLowStock: 'Onvoldoende voorraad, kan nie uitteken nie.',
            shop_order_cartHasExpiredGoods: 'Sommige winkelitems het verval, kan nie uitteken nie.',
            shop_order_typeIsNull: 'Besteltipe kan nie herken word nie, kontroleer asseblief die itemtipe.',
            shop_order_goodsNotFound: 'Produkinligting bestaan nie of is verwyder.',
            shop_order_giftNotForSale: 'Geskenkitems kan nie direk gekoop word nie.',
            common_message_badRequest: 'Ongeldige versoek, kontroleer asseblief die produk en parameters.',
        },
    },
    '手机号码最小长度为8位': 'Die minimum lengte van die selfoonnommer is 8 syfers',
    '邮箱账号名称最小长度为6位': 'Die minimum lengte van die e-posrekeningnaam is 6 karakters',
    '邮箱只能包含英文，数字等字符': 'Die posbus kan slegs karakters soos Engels en nommers bevat',
    '请选择正确的收货地址': 'Kies asseblief die korrekte afleweringsadres',
    Dict_language_status_0: 'Gedeaktiveer',
    Dict_language_status_1: 'Geaktiveer',
    Dict_member_label_type_1: 'Voorwaardelike etiket',
    Dict_member_label_type_2: 'Handmatige etiket',
    Dict_member_level_type_0: 'Verbruiksvlak (LV)',
    Dict_member_level_type_1: 'Betaalde lid (VIP)',
    Dict_member_growth_action_type_1: 'Plaas bestelling',
    Dict_member_growth_action_type_2: 'Daaglikse aanmelding',
    Dict_member_growth_action_type_3: 'Plaas beoordeling',
    Dict_member_growth_action_type_4: 'Voltooi profiel',
    Dict_paid_member_payment_type_0: 'Saldobetaling',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Geldig',
    Dict_paid_member_record_status_1: 'Verval',
    Dict_paid_member_record_status_2: 'Terugbetaal',
    Dict_point_lottery_prize_type_0: 'Punte',
    Dict_point_lottery_prize_type_1: 'Koepon',
    Dict_point_lottery_prize_type_2: 'Fisiese prys',
    Dict_point_lottery_prize_type_3: 'Dankie vir jou deelname',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-pos',
    Dict_notification_channel_type_2: 'Interne boodskap',
    Dict_notification_channel_type_3: 'Stootkennisgewing',
    Dict_announcement_status_0: 'Konsep',
    Dict_announcement_status_1: 'Gepubliseer',
    Dict_announcement_status_2: 'Onttrek',
    Dict_live_permission_status_0: 'Nie aansoek gedoen nie',
    Dict_live_permission_status_1: 'Onder hersiening',
    Dict_live_permission_status_2: 'Geaktiveer',
    Dict_live_permission_status_3: 'Afgekeur',
    Dict_live_room_status_0: 'Nie begin nie',
    Dict_live_room_status_1: 'Regstreeks',
    Dict_live_room_status_2: 'Geëindig',
    Dict_live_room_status_3: 'Abnormale onderbreking',
    Dict_live_room_type_0: 'Platform-uitsending',
    Dict_live_room_type_1: 'Handelaar-uitsending',
    Dict_store_type_0: 'Individuele winkel',
    Dict_store_type_1: 'Ondernemingswinkel',
    Dict_store_sign_status_0: 'Wag vir ondertekening',
    Dict_store_sign_status_1: 'Onderteken',
    Dict_store_sign_status_2: 'Beëindig',
    Dict_store_business_change_status_0: 'Wag vir hersiening',
    Dict_store_business_change_status_1: 'Goedgekeur',
    Dict_store_business_change_status_2: 'Afgekeur',
    Dict_decoration_page_type_0: 'Tuisblad',
    Dict_decoration_page_type_1: 'Kategorieblad',
    Dict_decoration_page_type_2: 'Veldtogblad',
    Dict_decoration_page_type_3: 'Pasgemaakte blad',
    Dict_decoration_status_0: 'Konsep',
    Dict_decoration_status_1: 'Gepubliseer',
    Dict_decoration_popup_trigger_page_0: 'Platform-tuisblad',
    Dict_decoration_popup_trigger_page_1: 'Lede-sentrum',
    Dict_decoration_popup_trigger_page_2: 'Betaling suksesvol',
    Dict_decoration_popup_target_user_0: 'Alle gebruikers',
    Dict_decoration_popup_target_user_1: 'Gratis lede',
    Dict_decoration_popup_target_user_2: 'Betaalde lede',
    Dict_decoration_popup_frequency_0: 'Een keer permanent',
    Dict_decoration_popup_frequency_1: 'Elke besoek',
    Dict_decoration_popup_frequency_2: 'Pasgemaakte frekwensie',
    Dict_track_event_type_page_view: 'Bladsybesigtiging',
    Dict_track_event_type_click: 'Klik',
    Dict_track_event_type_add_to_cart: 'Voeg by mandjie',
    Dict_track_event_type_search: 'Soek',
    Dict_track_event_type_purchase: 'Aankoop',
    Dict_track_event_type_live_watch: 'Kyk regstreeks',
    Dict_reconcile_period_type_0: 'Daagliks',
    Dict_reconcile_period_type_1: 'Weekliks',
    Dict_reconcile_period_type_2: 'Maandeliks',
    Dict_store_settlement_status_0: 'Wag vir vereffening',
    Dict_store_settlement_status_1: 'Vereffen',
    Dict_distributor_status_0: 'Wag vir hersiening',
    Dict_distributor_status_1: 'Hersien',
    Dict_distributor_status_2: 'Afgekeur',
    Dict_distribution_commission_type_0: 'Direkte kommissie',
    Dict_distribution_commission_type_1: 'Indirekte kommissie',
    Dict_configuration_status_0: 'Gedeaktiveer',
    Dict_configuration_status_1: 'Geaktiveer',
    ...afLocale
}
export default af